import {create} from "zustand";

type State = {
    opened: boolean;
    actions: {
        openModal: () => void;
        closeModal: () => void;
    }
};

export const useMobileMenuDrawerStore = create<State>((set) => ({
    opened: false,
    actions: {
        openModal: () => set({opened: true}),
        closeModal: () => set({opened: false}),
    }
}));
